"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let InvoiceEditor = class InvoiceEditor extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    labelAlign;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    defaultTitle;
    targetConfig;
    editor;
    async $$load_editor() {
        return this.invoice.editor();
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['labelAlign', 'formId', 'defaultTitle', 'targetConfig', 'editor', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                labelAlign: "right",
                formId: null,
                defaultTitle: this.$fn.pgettext("Invoice", "Edit Invoice"),
                targetConfig: {
                    header: {
                        title: this.$fn.pgettext("Invoice", "Edit Invoice Header"),
                        fieldsToSubmit: ["id",
                            "revision_id",
                            "etag",
                            "company",
                        ],
                    },
                },
                editor: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.target ? this.targetConfig[this.target].title : this.defaultTitle,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_3328_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_3334_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_crud_3332_getActionArgs($event) {
        return {
            objectType: "invoice",
            op: "upsert",
            data: {
                ...this.editor.getChanges({ skipEmbeddedLists: true }),
                id: this.editor.id,
                etag: this.editor.etag
            },
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_3336_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_3328 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_3328_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_3327 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_3328,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_3327],
        });
        const act_2248226175642056_closeComponent_3330 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_3329 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_3330,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_3329],
        });
        const act_1040167445267876_closeModal_3334 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_3334_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_3333 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_3334,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_crud_3332 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_3332_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_3333],
        });
        const evh_1040167445267876_submit_3331 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_3332,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_3331],
        });
        const act_1419464017721962_closeModal_3336 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_3336_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_3335 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_3336,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_3335],
        });
        return {
            act_7315092382398562_closeModal_3328,
            evh_7315092382398562_close_3327,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_3330,
            evh_2248226175642056_close_3329,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_3334,
            evh_1040167445267876_success_3333,
            act_1040167445267876_crud_3332,
            evh_1040167445267876_submit_3331,
            evh_1040167445267876_submit,
            act_1419464017721962_closeModal_3336,
            evh_1419464017721962_clickPreventStop_3335,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_crud_3332,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Object,
    }),
    __metadata("design:type", Object)
], InvoiceEditor.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceEditor.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], InvoiceEditor.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], InvoiceEditor.prototype, "onSize", null);
InvoiceEditor = __decorate([
    (0, vue_property_decorator_1.Component)()
], InvoiceEditor);
exports.default = InvoiceEditor;
vue_property_decorator_1.Vue.component("InvoiceEditor", InvoiceEditor);
